import { setNodes, insertText } from '@udecode/plate'
import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { editorDebug } from '~publish/legacy/editor/editorDebug'
import { getAllLinkNodes } from '../../link/nodes/getAllLinkNodes'
import {
  LinkedInAnnotationInputElement,
  type LinkedInAnnotationEntityDetails,
} from '../nodes/LinkedInAnnotationInputElement'
import { withoutLosingSelection } from '~publish/legacy/editor/helpers/withoutLosingSelection'

const debug = editorDebug.extend('plugins:linkedin-annotations')

export const insertLinkedInAnnotation = (
  editor: BufferEditor,
  annotation: LinkedInAnnotationEntityDetails,
): void => {
  const nodesWithEntityUrl = getAllLinkNodes(editor, {
    reverse: true,
  }).filter(([n]) => n.url === annotation.link && !n.isAnnotationProcessed)

  Array.from(nodesWithEntityUrl).forEach(([node, path]) => {
    debug('wrapping LinkedIn annotation: %s at %o', node.url, path)

    withoutLosingSelection(editor, () => {
      setNodes<LinkedInAnnotationInputElement>(
        editor,
        LinkedInAnnotationInputElement.new('', annotation),
        {
          at: path,
        },
      )

      insertText(editor, annotation.localizedName, {
        at: [...path, 0],
      })
    })
  })
}
